// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {Fragment, useContext, useEffect, useRef} from 'react';
import {Trans} from 'react-i18next';
import cn from 'classnames';
import zutil from 'zutil';
import hopt from 'hola_opt';
// @ts-ignore
import {cdn_url} from 'pub_config';
import {Settings_context} from '../../settings_ctx';
// @ts-ignore
import {App_context} from '../../context.js';
import {Agree_dialog} from '../../shared/agree_dialog/agree_dialog';
import {get_width, use_screen} from '../../lib/screen_util';
import {use_translation_v} from '../../lib/trans_v';
import {Install_btn} from '../install_btn';

import './hero.module.less';

const get_install_btn_opts = is_client=>{
    const {width} = use_screen();
    return {text: is_client && width < 768 ? 'Download Hola' : ''};
};

const Nbsp = ()=><Fragment>&nbsp;</Fragment>;

interface i_hero_props {
    users_number: number;
    user_country: string;
    wrapper_cls?: string;
    subtitle?: JSX.Element;
    title?: JSX.Element;
    animation?: JSX.Element;
    is_promo_browser?: boolean;
    column?: boolean;
}

export const Hero = (props: i_hero_props)=>{
    const video_ref = useRef<HTMLVideoElement>();
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const {theme, theme_name} = useContext(Settings_context);
    const {users_number, user_country, title, subtitle, column} = props;
    const {text: cta_text} = get_install_btn_opts(is_client);
    const anim = zutil.get(hopt, 'www_hola.animation.hp_hero_arc', {});
    useEffect(()=>{
        if (is_client && video_ref.current && get_width() < 768)
            return void video_ref.current.play();
    }, [is_client]);
    const on_anim_end = ()=>{
        if (is_client && video_ref.current)
            return void video_ref.current.play();
    };
    const {T} = use_translation_v({version: 0});
    const key = user_country=='RU' ? 'meta' : 'hero';
    const title_key = `hp.${key}.${theme_name=='purple' &&
        key=='hero' ? 'title_2lines' : 'title'}`;
    const sub_key = `hp.${key}.subtitle_2023`;
    const wrapper_cls = cn('hero_new-wrapper', props.wrapper_cls, column &&
        'column');
    const hero_cls = cn(theme.container, 'hero_new', column &&
        'column');
    const install_btn_cls = cn('hola_btn hola_btn--lg hola_btn--round',
        theme_name=='purple' && 'hola_btn-no_arrow',
        'hola_btn--txt_colored hola_btn--no_jump');
    const members_cls = cn('hero_new-members');
    return <div className={wrapper_cls}>
      <div className={hero_cls}>
        <div className="hero_new-text">
          <h1 className="hero_new-title">
            {title || <Trans i18nKey={title_key}/>}
          </h1>
          <h2 className={cn('hero_new-subtitle', theme.u2)}>
            {subtitle || <span className="monospace multicolor"><Trans
              i18nKey={sub_key}
              components={{Nbsp: <Nbsp/>, span: <span/>}}/></span>}
          </h2>
          <div className="hero_new-btn">
            <Install_btn src="main_add_btn" text={cta_text}
              user_country={user_country}
              download_browser={props.is_promo_browser}
              className={install_btn_cls} agree_dialog={Agree_dialog}/>
          </div>
          <div className={members_cls}>
            <T components={{b: <b/>}} i18nKey="hp.hero.members_count"
              values={{users_number}}/>
          </div>
        </div>
        <div className={cn('hero_new-animation', anim.cls)}
          onAnimationEnd={on_anim_end}>
          {props.animation || anim.type && <video muted playsInline
            preload="true" ref={video_ref}>
            <source src={`${cdn_url}${anim.src}`} type={anim.type}/>
          </video> || null}
        </div>
      </div>
    </div>;
};
